<template>
    <div class="blog-card-wrap">
        <div class="blog-cards container">
            <BlogCard :post="post" v-for="(post, index) in blogCardsArray" :key="index" />
        </div>
    </div>
</template>

<script>
import BlogCard from "../components/BlogCard";

export default {
    name: "events",
    components: {
        BlogCard
    },
    computed: {
        blogCardsArray() {
            return this.$store.state.blogCardsArray.slice().sort((a, b) => {
                // Parse dates for comparison
                const dateA = this.parseGermanDate(a.blogDate);
                const dateB = this.parseGermanDate(b.blogDate);
                // Sort in descending order (newest first)
                return dateB - dateA;
            });
        },
    },
    methods: {
        parseGermanDate(dateString) {
            // Convert German date format to JavaScript Date
            const monthMap = {
                'Januar': 'January', 'Februar': 'February', 'März': 'March',
                'April': 'April', 'Mai': 'May', 'Juni': 'June',
                'Juli': 'July', 'August': 'August', 'September': 'September',
                'Oktober': 'October', 'November': 'November', 'Dezember': 'December'
            };

            // Replace German month names with English ones
            let englishDate = dateString;
            for (const [german, english] of Object.entries(monthMap)) {
                englishDate = englishDate.replace(german, english);
            }

            return new Date(englishDate);
        }
    },
};
</script>

<style lang="scss" scoped>

.blog-cards {
    position: relative;
}

</style>